import { useState, useEffect } from 'react';
const useDataHook = (url, params = {}) => {
    const [errors, setErrors] = useState(null);
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);
    useEffect(
        () => {
            const doFetch = async () => {
                try {
                    const resp = await fetch(url);
                    const dataraturn = await resp.json();
                    setData(dataraturn);
                    setLoading(false);
                } catch (e) {
                    setLoading(false);
                    setErrors(e);
                }
            }
            doFetch();
        }, [url, params]
    );
    return [loading, data, errors];
}

export default useDataHook;